import * as Types from '@/types';

import { gql } from '@apollo/client';
export const SalesPortalOrderGuides_OrderGuideRestaurantCollectionFieldsFragmentDoc = gql`
  fragment SalesPortalOrderGuides_OrderGuideRestaurantCollectionFields on order_guide_restaurant_collection {
    order_guide_restaurant_partitions(
      order_by: [{ sort_order: asc_nulls_last }, { name: asc_nulls_last }]
    ) {
      is_default
      name
      sort_order
      uuid
    }
    is_default
    name
    uuid
  }
`;
